import { PropTypes } from 'prop-types'
import { applicationPropType } from './application-prop-type'

/**
 * @typedef {Object} ApplicationGroup
 * @property {string} [applicationGroupId] - ID of the application group.
 * @property {string} [name] - The unique name of the application group. Use stringCode to resolve a proper translation
 *   for the display name.
 * @property {string} [stringCode] - The string code to be used to resolve a translated display name.
 * @property {Array<Application>} [applications] - Available applications.
 */
export const applicationGroupPropType = PropTypes.shape({
    applicationGroupId: PropTypes.string,
    applications: PropTypes.arrayOf(applicationPropType),
    name: PropTypes.string,
    stringCode: PropTypes.string
})
